import { useSelector } from 'react-redux';
import { useNavigation } from '~/Hooks';
import { selectBookedListLength } from '~/store/bookings';
import { selectEventById } from '~/store/events';
import { selectLocationList, selectTrainerById } from '~/store/provider';
import { EventType } from '~/Models/DTO/Event.model';

export const useEventPageInformationDesktop = () => {
  // hooks
  const { getParams } = useNavigation();
  const { id } = getParams();

  // selectors
  const selectedEvent = useSelector(selectEventById(id || ''));
  const trainer = useSelector(selectTrainerById(selectedEvent?.trainerIds[0] || ''));
  const locations = useSelector(selectLocationList);
  const totalBookings = useSelector(selectBookedListLength);

  const eventLocation = locations.find((loc) => loc.uuid === selectedEvent?.locationId);

  const trainerName = trainer ? `${trainer.shortenedFirstName} ${trainer.shortenedLastName}` : '';

  const isFreeTraining = selectedEvent?.type === EventType.FREE_TRAINING;

  return {
    trainerString: trainerName,
    locationName: eventLocation?.name || '',
    totalBookings,
    totalSeats: selectedEvent?.seats,
    cancelled: selectedEvent?.cancelled,
    isFreeTraining,
  };
};
